import React from "react";
import styled from "styled-components";

import { Spinner } from "./Spinner";

export const LoadingIndicatorWrapper = styled.div<{ $size?: number }>`
  width: 100%;
  height: ${(p) => p.$size ?? 200}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoadingIndicator = (props: { title: string; size?: number }) => (
  <LoadingIndicatorWrapper title={props.title} $size={props.size}>
    <Spinner size={props.size} />
  </LoadingIndicatorWrapper>
);
